import { formatAmountValue } from 'components/util/MoneyDisplay';
import { GLOBAL_SEARCH_ENTITY_ICON } from 'components/global-search/entityDisplay';
import { InvoiceData } from 'types/invoices';
import { familyTileClass } from 'utils/families';
import { t } from 'utils/getTranslations';

/** The section of an other fee's or an admin fee's dialog that holds what Required does not. */
export const FEE_DETAILS_SECTION = 'invoices.totals-tab.details';

/** A fee dialog's amount in the new design: set at the end in tabular figures, written as an amount when left. */
export const FEE_AMOUNT_FIELD = {
    wrapperClassName: '[&_input]:text-end [&_input]:tabular-nums',
    formatValue: formatAmountValue,
};

/** How a fee's dialog is headed in the new design: the invoice's glyph and family, and the case the fee is on. */
export function feeDialogRecord(invoice: InvoiceData, matterId: number) {
    const caseNumber = invoice.invoiceMatters?.find((matter) => matter.matterId === matterId)?.matterNumber;

    return {
        icon: GLOBAL_SEARCH_ENTITY_ICON.INVOICE,
        tileClass: familyTileClass('finance'),
        chip: caseNumber ? t('create-dialog.context.for', { name: caseNumber }) : null,
    };
}
